import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { BREAKPOINTS } from '../../settings';


const Image = ({ url, alt, overflow = true }) => {
  return <StyledImage src={url} alt={alt} className={`${overflow ? 'overflow' : ''}`} />
};

Image.propTypes = {
  url: PropTypes.string,
  alt: PropTypes.string,
  overflow: PropTypes.bool,
};

const StyledImage = styled.img`
  margin-bottom: 20px;
  max-width: none;
  width: 100%;

  &.overflow {
    @media (min-width: ${BREAKPOINTS.sm}) {
      margin: 0 -30px 20px -30px;
      width: calc(100% + 60px);
    }
  }
`;

export default Image;
